import React, { useState, useEffect } from 'react';
import { Phone, MessageCircle, X } from 'lucide-react';

export default function FloatingContact() {
  const [visible, setVisible] = useState(false);
  const [open, setOpen] = useState(true);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3">
      {open && (
        <div className="bg-white rounded-2xl shadow-2xl border border-slate-200 p-4 pr-9 max-w-[240px] relative">
          <button onClick={() => setOpen(false)} className="absolute top-2 right-2 text-slate-400 hover:text-navy" aria-label="close">
            <X className="w-3.5 h-3.5" />
          </button>
          <div className="text-[10px] uppercase tracking-wider text-brand font-bold">Free Guidance</div>
          <div className="font-heading text-lg font-extrabold text-navy mt-0.5">1:1 Counselling</div>
          <div className="text-xs text-slate-500 mt-1">Talk to a verified counsellor. No signup.</div>
        </div>
      )}

      <div className="flex flex-col gap-3">
        <a
          href="https://wa.me/919509406802"
          target="_blank" rel="noreferrer"
          className="w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-xl hover:scale-110 transition-transform relative"
          aria-label="WhatsApp"
        >
          <MessageCircle className="w-6 h-6" fill="currentColor" strokeWidth={0} />
          <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
        </a>
        <a
          href="tel:+919509406802"
          className="w-14 h-14 rounded-full bg-brand text-white flex items-center justify-center shadow-xl hover:scale-110 transition-transform"
          aria-label="Call"
        >
          <Phone className="w-5 h-5" strokeWidth={2.2} />
        </a>
      </div>
    </div>
  );
}
